var React = require('react');
var defaultMessages = require('../../i18n/messages/default.js');
var AppConstants = require('../../constants/AppConstants');
var { Card, Text, Heading } = require('@metro-ui/core');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var defaultMessages = require('../../i18n/messages/default');
var { ArrowLeft } = require('@metro-ui/icons');

class UserAuthMethods extends React.Component {
    constructor(props) {
        super(props);
    }

    renderAuthMethodsList() {
        const authMethodsToDisplay = this.props.userMFAMethods.filter(authMethod => authMethod.name !== this.props.authMethodDeviceName);
        const authMethods = authMethodsToDisplay.map((authMethodItem, i) => {
            const authMethodKey = AppConstants.USER_AUTHMETHODS[authMethodItem.authenticationMethod].headerMessageKey;
            return (
                <Card key={i}
                    spacing="large"
                    padding="medium"
                    className="font-medium cursor"
                    onClick={this.props.setAuthenticationMethodOnClick.bind(this, authMethodItem)}>
                    <Text size="medium" color="brand-primary">
                        {this.props.intl.formatMessage(defaultMessages[authMethodKey])}
                        <span className="metro-blue font-small"> ({authMethodItem.name}) </span>
                    </Text>
                </Card>
            )
        });
        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="col-lg-1 col-md-1 col-sm-0 col-xs-0"></div>
                    <div className="col-lg-12 col-md-10 col-sm-12 col-xs-12 loginFields">
                        <div className="authMethods-card metro-blue">
                            <Heading
                                padding="large"
                                size="large"
                                color="primary"
                                className="cursor user-authmethods-heading"
                                onClick={this.props.showMFAMethods}
                            >
                                <ArrowLeft
                                    size={1}
                                    color="blue"
                                    className="icon-font"
                                />&nbsp;
                                {this.props.intl.formatMessage(defaultMessages['choose_2fa_method'])}
                            </Heading>
                            {authMethods}
                        </div>
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-0 col-xs-0"></div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.renderAuthMethodsList()}
            </div>
        );
    }
}

module.exports = injectIntl(UserAuthMethods);